import React, { ReactNode } from "react";
import classnames from "classnames";

import { IValidation } from "@formant/core/model/IValidation";
import { Page } from "@formant/ui/component/common/Page";

import { useStores } from "../../../context/StoreContext";
import { FlexSpacer } from "../FlexSpacer";
import { Header } from "../Header";
import { Heading1 } from "../Heading1";
import { ITabsVariantProps } from "./ITabsVariantProps";
import { TabButtons } from "./TabButtons";
import { TabContent } from "./TabContent";
import * as styles from "./Tabs.scss";

interface ITabProps extends ITabsVariantProps {
    hideTitle?: boolean;
    children?: ReactNode;
    onBack?: () => void;
    validation?: IValidation;
}

export function Tabs(props: ITabProps) {
    const {
        title,
        hideTitle,
        tabs,
        selected,
        onSelected,
        onBack,
        className,
        children,
        validation,
    } = props;

    const { authStore, routerStore } = useStores();

    const { navigate, routeTo } = routerStore;

    const isKiosk = authStore.hasAccess("kiosk");

    return (
        <Page className={classnames(styles.tabs, styles.top, className)}>
            <div className={styles.navigation}>
                <Header
                    className={styles.header}
                    title={title}
                    hideMenu={isKiosk}
                    hideTitle={true}
                    onBack={
                        isKiosk
                            ? async () => {
                                  await navigate(routeTo.home());
                              }
                            : onBack
                    }
                >
                    {!hideTitle && (
                        <Heading1
                            data-testid="heading-title"
                            className={styles.title}
                        >
                            {title}
                        </Heading1>
                    )}

                    {children !== undefined && (
                        <div className={styles.children}>{children}</div>
                    )}

                    <TabButtons
                        mode="top"
                        tabs={tabs}
                        selected={selected}
                        className={styles["tabs-buttons"]}
                        onSelected={onSelected}
                        validation={validation}
                    />
                    <FlexSpacer className={styles.spacer} />
                </Header>
                <div className={styles.mobile}>
                    <TabButtons
                        mode="top"
                        tabs={tabs}
                        selected={selected}
                        onSelected={onSelected}
                        validation={validation}
                    />
                </div>
            </div>
            <TabContent
                className={styles.content}
                tabs={tabs}
                selected={selected}
            />
        </Page>
    );
}
